export const loadDarkMode = () => {
  const storedTheme = localStorage.getItem("color-theme");

  let isDark = false;

  if (storedTheme === "dark") {
    isDark = true;
  } else if (storedTheme === "light") {
    isDark = false;
  } else {
    // No theme stored, check system preference
    isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  if (isDark) {
    document.documentElement.classList.add("dark");
    document.body.classList.add("bg-gray-800");
  } else {
    document.documentElement.classList.remove("dark");
    document.body.classList.remove("bg-gray-800");
  }

  return isDark;
};

export const setDarkMode = (toggle) => {
  if (toggle) {
    document.documentElement.classList.add("dark");
    document.body.classList.add("bg-gray-800");
    localStorage.setItem("color-theme", "dark");
  } else {
    document.documentElement.classList.remove("dark");
    document.body.classList.remove("bg-gray-800");
    localStorage.setItem("color-theme", "light");
  }
};
